import React from 'react';

import { BeforeAndAfter } from '../../_components/BeforeAndAfter';
import { BeforeAndAfterProps } from './types';

import classes from './index.module.scss';

export const BeforeAndAfterGraphQL: React.FC<BeforeAndAfterProps> = props => {
  const {
    id,
  } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <BeforeAndAfter beforeAndAfter={props} />
    </div>
  );
};

export default BeforeAndAfterGraphQL;
